import React from 'react';
import Section from './Section';
import { GraduationCap, MapPin } from 'lucide-react';

export default function About() {
    return (
        <Section id="about" className="bg-warm-grey">
            <h2 className="text-3xl font-serif font-bold text-center text-charcoal mb-16">About Me</h2>

            <div className="grid md:grid-cols-2 gap-12 text-charcoal/80">
                <div className="space-y-6">
                    <h3 className="text-xl font-serif text-charcoal text-center md:text-left flex items-center justify-center md:justify-start gap-2">
                        <GraduationCap className="text-earth-brown" size={24} />
                        Education
                    </h3>
                    <div className="bg-warm-white p-8 rounded-sm shadow-sm border border-stone-100">
                        <p className="text-lg font-medium text-charcoal">Arizona State University</p>
                        <p className="text-earth-brown font-serif italic mb-4">Bachelor of Science, Computer Science</p>
                        <div className="flex justify-between text-sm text-charcoal/60 uppercase tracking-wider">
                            <span>Aug 2021 – May 2025</span>
                            <span>GPA: 3.85/4.0</span>
                        </div>
                    </div>
                </div>

                <div className="space-y-6">
                    <h3 className="text-xl font-serif text-charcoal text-center md:text-left flex items-center justify-center md:justify-start gap-2">
                        <MapPin className="text-earth-brown" size={24} />
                        Overview
                    </h3>
                    <div className="bg-warm-white p-8 rounded-sm shadow-sm border border-stone-100 h-full flex flex-col justify-center">

                        <p className="leading-relaxed">
                            I specialize in building full-stack applications and have a strong foundation in machine learning. I'm passionate about creating software that solves real-world problems with clean code and intuitive design.
                        </p>
                    </div>
                </div>
            </div>
        </Section>
    );
}
